import React from 'react';
import { TableRow } from '@mui/material';
import { FormAutocomplete } from '~/components/FormComponents/FormAutocomplete.tsx';
import { FormDateInput } from '~/components/FormComponents/FormDateInput.tsx';
import { FormInput } from '~/components/FormComponents/FormInput.tsx';
import { FinancialConditionTableCell } from '~/modules/covenants/CovenantsDataApplicationForm/documentGeneration/financialCondition/components/shared/FinancialConditionTableCell.tsx';
import { FinancialConditionTableDeleteCell } from '~/modules/covenants/CovenantsDataApplicationForm/documentGeneration/financialCondition/components/shared/FinancialConditionTableDeleteCell.tsx';
import type { IFinancialAssistanceRowProps } from '~/modules/covenants/CovenantsDataApplicationForm/documentGeneration/financialCondition/components/financialAssistance/types.ts';
import { FINANCIAL_CONDITION_FIELD_LABELS } from '~/modules/covenants/CovenantsDataApplicationForm/documentGeneration/financialCondition/constants.ts';
import {
  normalizeBalanceLine,
  normalizeDecimalValue,
  validateBalanceLine,
} from '~/modules/covenants/CovenantsDataApplicationForm/documentGeneration/financialCondition/utils.ts';
import { documentGenerationFormStyles } from '~/modules/covenants/CovenantsDataApplicationForm/documentGeneration/styles.ts';
import { financialConditionTableFieldStyles } from '~/modules/covenants/CovenantsDataApplicationForm/documentGeneration/financialCondition/styles.ts';

export const FinancialAssistanceRow: React.FC<IFinancialAssistanceRowProps> = ({
  name,
  index,
  canRemove,
  issueOrReceiptDateLabel,
  disabled,
  currencyOptions,
  isCurrenciesLoading,
  onRemove,
}) => (
  <TableRow>
    <FinancialConditionTableCell>
      <FormInput
        name={`${name}.${index}.counterpartyName`}
        label="Найменування контрагента"
        placeholder="За наявності зазначте належність до ГПК/ГСК"
        disabled={disabled}
        fullWidth
        sx={documentGenerationFormStyles.field}
      />
    </FinancialConditionTableCell>
    <FinancialConditionTableCell>
      <FormAutocomplete
        name={`${name}.${index}.currency`}
        label={FINANCIAL_CONDITION_FIELD_LABELS.currency}
        options={currencyOptions}
        preserveOptionsOrder
        loading={isCurrenciesLoading}
        disabled={disabled}
        fullWidth
        sx={documentGenerationFormStyles.field}
      />
    </FinancialConditionTableCell>
    <FinancialConditionTableCell>
      <FormInput
        name={`${name}.${index}.outstandingDebt`}
        label="Заборгованість, тис. од."
        type="text"
        inputProps={{ inputMode: 'decimal' }}
        normalizeOnBlur={normalizeDecimalValue}
        disabled={disabled}
        fullWidth
        sx={documentGenerationFormStyles.field}
      />
    </FinancialConditionTableCell>
    <FinancialConditionTableCell>
      <FormDateInput
        name={`${name}.${index}.issueOrReceiptDate`}
        label={issueOrReceiptDateLabel}
        disabled={disabled}
        sx={financialConditionTableFieldStyles.dateField}
      />
    </FinancialConditionTableCell>
    <FinancialConditionTableCell>
      <FormDateInput
        name={`${name}.${index}.maturityDate`}
        label={FINANCIAL_CONDITION_FIELD_LABELS.maturityDate}
        disabled={disabled}
        sx={financialConditionTableFieldStyles.dateField}
      />
    </FinancialConditionTableCell>
    <FinancialConditionTableCell>
      <FormInput
        name={`${name}.${index}.balanceLine`}
        label={FINANCIAL_CONDITION_FIELD_LABELS.balanceLine}
        placeholder="р.1550"
        normalizeOnBlur={normalizeBalanceLine}
        rules={{ validate: validateBalanceLine }}
        inputProps={{ inputMode: 'numeric', maxLength: 6 }}
        disabled={disabled}
        fullWidth
        sx={financialConditionTableFieldStyles.balanceLineField}
      />
    </FinancialConditionTableCell>
    <FinancialConditionTableCell>
      <FormInput
        name={`${name}.${index}.overdueDebt`}
        label="Прострочення, тис. од."
        type="text"
        inputProps={{ inputMode: 'decimal' }}
        normalizeOnBlur={normalizeDecimalValue}
        disabled={disabled}
        fullWidth
        sx={documentGenerationFormStyles.field}
      />
    </FinancialConditionTableCell>
    <FinancialConditionTableDeleteCell
      label={`Видалити допомогу ${index + 1}`}
      disabled={disabled}
      hidden={!canRemove}
      onDelete={onRemove}
    />
  </TableRow>
);
